import { BaseEntity } from './base-raptor-models';
import { Customer } from './customer.model';
import { Vehicle } from './vehicle.model';
import { WorkOrder } from './work-order.model';

export enum DispatchEquipmentType {
    Unknown = 'Unknown',
    Trailer = 'Trailer',
    Tractor = 'Tractor',
    Intermodal = 'Intermodal',
}

export enum DispatchStatus {
    Pending = 'Pending',
    Completed = 'Completed',
}

export interface DispatchServiceInfo extends BaseEntity {
    dispatchId: string;
    position: string;
    tirePreference?: string | null;
    tireSize: string | null;
    tireType: string | null;
    tireReason: string | null;
}

export interface Dispatch extends BaseEntity {
    createdOn: Date;
    customerId?: string | null;
    customer?: Customer;
    customerType?: string | null;
    dealerNumber: string;
    driverFirstName: string | null;
    driverLastName: string | null;
    driverPhoneNumber: string | null;
    driverEmail: string | null;
    dispatcherFirstName: string | null;
    dispatcherLastName: string | null;
    dispatcherPhoneNumber: string | null;
    dispatcherEmail: string | null;
    equipmentId: string;
    equipmentType: DispatchEquipmentType;
    eventId: string;
    fleetId: string;
    fleetName: string;
    fleetSoldToNumber?: string | null;
    poNumber: string;
    services: DispatchServiceInfo[];
    status: DispatchStatus;
    vehicleId?: string | null;
    vehicle?: Vehicle;
    workOrderId?: string | null;
    workOrder?: WorkOrder;
}

export function createMockDispatch(overrides: Partial<Dispatch> = {}): Dispatch {
    const defaultDispatch: Dispatch = {
        id: 'mock-dispatch-id',
        tenantId: 'mock-tenant-id',
        branchId: 'mock-branch-id',
        createdOn: new Date(),
        dealerNumber: 'DEALER-001',
        driverFirstName: 'John',
        driverLastName: 'Doe',
        driverPhoneNumber: '555-1234-5678',
        driverEmail: null,
        dispatcherFirstName: 'Jane',
        dispatcherLastName: 'Smith',
        dispatcherPhoneNumber: '555-5678-1234',
        dispatcherEmail: null,
        equipmentId: 'EQUIP-001',
        equipmentType: DispatchEquipmentType.Trailer,
        eventId: 'EVENT-001',
        fleetId: 'FLEET-001',
        fleetName: 'Mock Fleet',
        poNumber: 'PO-001',
        services: [],
        status: DispatchStatus.Pending,
    };

    return {
        ...defaultDispatch,
        ...overrides,
    };
}
